import Config from './types/config';

const config: Config = {
  imagesPath: 'images',
  videosPath: 'videos',
  filesPath: 'files',
  maxItemsToRenderInHomePage: {
    publications: 5,
    projects: 5,
  },
};

export default config;
